<template lang="pug">
    article#noticias
        Banner
        Destaque(:destaque="destaque")
        Listagem(:listagem="listagem")
</template>

<script>
import qs from 'qs'
import Banner from '@sections/Noticias/Banner/Banner.vue'
import Listagem from '@sections/Noticias/Listagem/Listagem.vue'
import Destaque from '@sections/Noticias/Destaque/Destaque.vue'

import pagina from '@/mixins/pagina'

export default {
    name: "view-noticias",
    components: {
        Banner,
        Destaque,
        Listagem
    },
    mixins: [
        pagina
    ],
    data() {
        return {
            listagem: {},
            pagination: {
                limit: 10,
                skip: null,
                sort: '-published_at',
                q: '',
                fields: '',
                page: 1
            },
            destaque: {}
        }
    },
    created() {
        this.loadNoticias();
    },
    methods: {
        loadNoticias(isPaginate = 0) {
            let params = Object.assign({}, this.pagination, {
                limit: isPaginate ? this.pagination.limit - 1 : this.pagination.limit,
                skip: isPaginate ? this.listagem.data[0].slug : null
            })

            this.$axios
                .get(`noticias?${qs.stringify(params)}`)
                .then(response => {
                    let tempData = Object.assign({}, response.data)

                    if (typeof this.listagem.data === 'undefined') {
                        this.listagem = tempData
                        this.destaque = this.listagem.data.shift()
                    } else {
                        tempData.data = this.listagem.data.concat(tempData.data)
                        this.listagem = tempData
                    }
                })
                .catch(() => {
                    this.listagem = {}
                    this.destaque = {}
                })
        },
        goToPage(pPage) {
            this.pagination.page = pPage;
            this.loadNoticias(pPage);
        }
    },
}
</script>

<style lang="stylus" scoped src="./Noticias.styl"></style>